import { ControlConstants } from "@lib/titan2/dist/game/control/constant/ControlConstants";
import { AbstractDemoPlayProperties } from "@lib/titan2/dist/game/view/properties/AbstractDemoPlayProperties";
import * as PIXI from "pixi.js";
/**
 * DemoPlayTabletProperties.ts
 */
export class DemoPlayLandscapeProperties extends AbstractDemoPlayProperties {
    setDefaultValues() {
        super.setDefaultValues();
        this.backgroundProperties.position = new PIXI.Point(171, 0);
        this.labelProperties.position = new PIXI.Point(55, 10);
        this.labelProperties.size = new PIXI.Point(120, 50);
        this.labelProperties.horizontalAlign = ControlConstants.CENTER;
        this.labelProperties.rotation = -25;
    }
}
//# sourceMappingURL=DemoPlayLandscapeProperties.js.map